namespace GeniuzPOS.AdvPromo {
    export class PsAdvPromoItemColumns {
        static columnsKey = 'AdvPromo.PsAdvPromoItem';
    }
}
